import { render, staticRenderFns } from "./OtpInputBox.vue?vue&type=template&id=363ab74a&scoped=true"
import script from "./OtpInputBox.vue?vue&type=script&lang=js"
export * from "./OtpInputBox.vue?vue&type=script&lang=js"
import style0 from "./OtpInputBox.vue?vue&type=style&index=0&id=363ab74a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363ab74a",
  null
  
)

export default component.exports